import React from 'react';
import { Box } from '@flexisaf/flexibull2';
import AutoLoadSelect from 'components/AutoLoadSelect';
import PropTypes from 'prop-types';
import urls from 'utils/config';
import request from 'utils/request';

const { API_BASE_URL } = urls || {};

const LocationPosting = ({ location, handleChange, batch, label, isClearable }) => {

  async function loadOptions(search, loadedOptions, { page }) {
    try {
      const pageSize = 20;
      const url = `${API_BASE_URL}/locations?page=${
        (page - 1) * pageSize
      }&size=${pageSize}`;
      const response = await request({
        method: 'get',
        url,
      });
      if (response.success) {
        const options = response?.raw?.data.map((a) => ({
          label: `${a.name}`,
          value: a.id,
          ...a,
        }));
        const resultTotal = +response?.raw?.resultTotal;

        return {
          options: options,
          hasMore: resultTotal > +loadedOptions?.length + options.length,
          additional: {
            page: page + 1,
          },
        };
      }
    } catch {}
  }

  return (
    <Box>
      <AutoLoadSelect
        label={label || `Select Location to post applicant${batch ? `(s)` : ''}`}
        value={location}
        defaultOptions
        debounceTimeout={700}
        loadOptions={loadOptions}
        onChange={(e) => {
          handleChange(e);
        }}
        isClearable={isClearable ? true : false}
        additional={{
          page: 1,
        }}
      />
    </Box>
  );
};

LocationPosting.propTypes = {
  location: PropTypes.object,
  handleChange: PropTypes.func,
  batch: PropTypes.bool,
  label: PropTypes.string,
  isClearable: PropTypes.any
};

export default LocationPosting;
